import React from "react";
import Table from "./Table";
import { Grid } from "@mui/material";

export default function TableUserDocuments(props) {

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "first_name",
        width: 500,
        minWidth: 100,
      },
      {
        Header: "Last_Name",
        accessor:"last_name",
        width: 500,
        minWidth: 80,
      },
      {
        Header: "Email",
        accessor: "email",
        width: 500,
        minWidth: 80,
      },

      {
        Header: "Documents",
        accessor: "Documents",
        width: 500,
        minWidth: 80,
      },
    ],
    []
  );

  const data = React.useMemo(() => props.user_details.user_details, [props]);
  const myArray = [data];
  const data2 = React.useMemo(() => [
    {
        "first_name": "First name",
        "last_name": "Last Name",
        "email": "test@email.com",

 
    },])

  return (
    <>
    {/* {console.log(myArray)}
    {console.log(data2)} */}
     <Grid container spacing={2}>
                <Grid item xs={0} sm={1} />
                <Grid container id="app-table" item xs={12} sm={10}>
      <Table columns={columns} data={myArray} />
      </Grid></Grid>
    </>
  );
}
